module.exports = __webpack_public_path__ + "img/searchService.753aab20.svg";